import axios from '../../axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    fetchCoSignInsByContact({ commit, dispatch, getters }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`/core/cosignins/contact/${id}`, {
        }).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    addNewCoSignIn({ commit, dispatch, getters }, newCoSignIn) {
      return new Promise((resolve, reject) => {
        axios.post('/core/cosignins/profile', newCoSignIn).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    archiveCoSignIn({ commit, dispatch, getters }, coSignInId) {
      return new Promise((resolve, reject) => {
        axios.post(`/core/cosignins/${coSignInId}/archive`).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },

  },
};
